import BannerA from '../../components/BannerA';
import FaqA from '../../components/FaqA';
import FooterTcA from '../../components/FooterTcA';
import GoodsA from '../../components/GoodsA';
import ListA1 from '../../components/ListA1';
import ListA2 from '../../components/ListA2';
import SectionA1 from '../../components/SectionA1';
import SectionA2 from '../../components/SectionA2';
import SectionA3 from '../../components/SectionA3';
import SectionA4 from '../../components/SectionA4';
import SectionA5 from '../../components/SectionA5';
import SectionA6 from '../../components/SectionA6';
import SectionA7 from '../../components/SectionA7';
import SectionA8 from '../../components/SectionA8';
import SectionB1 from '../../components/SectionB1';
import SectionB2 from '../../components/SectionB2';

export default function StatusItem() {
    return (
        <>
            <BannerA />
            <SectionA1 />
            <GoodsA />
            <SectionA2 />
            <SectionA3 />
            <SectionB1 />
            <SectionA4 />
            <SectionA5 />
            <SectionA6 />
            <ListA1 />
            <FaqA />
            <SectionB2 />
            <ListA2 />
            <SectionA7 />
            <SectionA8 />
            <FooterTcA />
        </>
    );
}
